import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
/**
 * Livy is an add-on to the page, so a render error inside it hides Livy rather than blanking Livable Pro: React
 * unmounts the whole tree on an uncaught render error, and the app has no other boundary.
 */
export class LivyErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      failed: false
    });
  }
  static getDerivedStateFromError() {
    return {
      failed: true
    };
  }
  componentDidCatch(error) {
    console.error('[livy] render failed; Livy hidden for this page load', error);
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}